import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import StyleSheet from 'styles'
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { User } from 'containers'
import Dependent from 'containers/shared/Dependent'
import { Authorization } from 'utils'
import { DealSheetActions, UserSelectionActions, SnackbarActions } from 'actionsets'
import { CenteredContent } from 'containers'
import { Pagination } from 'components'
import CollapsibleTable, {TableHead, TableBody, TableRow, TableCell} from 'components/CollapsibleTable'
import IconButton from '@material-ui/core/IconButton'
import DeleteIcon from '@material-ui/icons/Delete'
import AppBar from '@material-ui/core/AppBar'

export class Viewers extends Component {

  static propTypes = {
    dealSheet: PropTypes.object.isRequired
  }

  constructor(props){
    super(props)
    this.state = {
      ...this.state,
      permittedViewers: {
        currentPage: 1
      },
      restrictedViewers: {
        currentPage: 1
      }
    }

    DealSheetActions.bindActions(this)
    UserSelectionActions.bindActions(this, 'userSelect')
    SnackbarActions.bindActions(this, 'snackbar')
  }

  dependsOn(){
    this.actions.resetState()
    return this.actions.show({id: this.props.match.params.id}).then(() => {
      this.load()
    })
  }

  dependenciesMet(){
    return !!(
      this.props.requests.length === 0
        && this.props.dealSheet
        && this.props.permittedViewers.values
        && this.props.restrictedViewers.values
    )
  }

  get onCloseRoute() {
    return `/deal_sheets_admin/status/${this.props.dealSheet.status}`
  }

  get canAddViewers(){
    return Authorization.admin
  }

  get canPublish(){
    return this.canAddViewers && this.props.dealSheet.status === 'approved' && this.props.dealSheet.wallet.status === 'ready'
  }

  addPermissions = async () => {
    const userIds = await this.actions.userSelect.makeSelection({title: 'Permit:', actionName: 'Permit'})
    try{
      await this.actions.permitViewers(this.props.dealSheet.id, userIds)
    }catch(err){
      this.actions.snackbar.error('Failed to add new viewers!')
    }
    this.load()
  }

  addRestrictions = async () => {
    const userIds = await this.actions.userSelect.makeSelection({title: 'Restrict:', actionName: 'Restrict'})
    try{
      await this.actions.restrictViewers(this.props.dealSheet.id, userIds)
    }catch(err){
      this.actions.snackbar.error('Failed to exclude viewers!')
    }
    this.load()
  }

  removeViewer = async (user) => {
    try {
      await this.actions.removeViewer(this.props.dealSheet.id, user.id)
    }catch(err){
      this.actions.snackbar.error('Failed to remove viewer!')
    }
    this.load()
  }

  publish = async () => {
    try{
      await this.actions.createEvent(this.props.dealSheet.id, { name: 'publish' })
      this.close()
    }catch(err){
      this.actions.snackbar.error('Failed publish!')
    }
  }

  close = () => {
    this.props.history.push(this.onCloseRoute)
  }

  load = async () => {
    try {
      await this.actions.loadPermittedViewers(this.permittedViewers.currentPage, { action: 'show' })
      await this.actions.loadRestrictedViewers(this.restrictedViewers.currentPage, { action: 'show' })
    } catch(err){
      this.actions.snackbar.error('Failed to load viewers!')
    }
  }

  get permittedViewers(){
    return this.state.permittedViewers
  }

  get restrictedViewers(){
    return this.state.restrictedViewers
  }

  handleGoToPage = scope => page => {
    this.setState({[scope]: {...this.state[scope], currentPage: page}}, this.load)
  }

  handleTabChange = (event, selectedTab) => {
    this.props.history.push(`/deal_sheets/${this.props.dealSheet.id}/viewers/${selectedTab}`)
  }


  get selectedTab(){
    return this.props.match.params.tab
  }

  totalPages = scope =>{
    let totalPages = this.props[scope] && this.props[scope].totalPages
    return (!!totalPages) ? totalPages : 0
  }

  renderPagination(scope){
    return(
      <Pagination className={styles.pagination} totalPages={this.totalPages(scope)}
        page={this.state[scope].currentPage}
        onPageSelected={this.handleGoToPage(scope)}/>
    )
  }

  renderViewersList = values =>{
    if(values.length === 0) {
      return (
        <div className={styles.emptyList}>No viewers selected.</div>
      )
    }
    return (
      <CollapsibleTable>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Account Name</TableCell>
            <TableCell className={styles.actionButtons}></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {values.map((viewer) =>
            <TableRow key={ viewer.id }>
              <TableCell mobileHeading>{viewer.name}</TableCell>
              <TableCell mobileLabel="Email">{viewer.email}</TableCell>
              <TableCell mobileLabel="Account Name">{viewer.investorAccountName}</TableCell>
              <TableCell className={styles.actionButtons}><IconButton onClick={() => this.removeViewer(viewer)}><DeleteIcon /></IconButton></TableCell>
            </TableRow>
          )}
        </TableBody>
      </CollapsibleTable>
    )
  }

  renderViewers = (scope, title) => {
    const { [scope]: { values=[] }={} } = this.props
    return (
      <div className={styles.userList}>
        { this.renderPagination(scope) }
        { this.renderViewersList(values) }
        { this.renderPagination(scope) }
      </div>
    )
  }

  renderErrorMessage = () => {
    return (
      <Typography variant='subtitle1'>{`Not authorized to update viewers on deal sheet: "${this.props.dealSheet.tagLine}"`}</Typography>
    )
  }

  render() {
    const {dealSheet} = this.props
    return(
      <CenteredContent>
        <div className={styles.headerRow}>
          <Typography variant='h5'>{dealSheet.name || 'New Deal'}{dealSheet.ticker && `(${dealSheet.ticker})`}</Typography>
          {this.canAddViewers &&
          <div>
            <Button onClick={this.addPermissions} variant='contained' color='primary'>Permit users</Button>
            <Button onClick={this.addRestrictions} variant='contained' color='primary'>Restrict users</Button>
          </div>
          }
        </div>
        <AppBar position="static" color="inherit" className={styles.tabBar}>
          {this.canAddViewers &&
            <Tabs value={this.selectedTab} onChange={this.handleTabChange}
                  variant='scrollable' scrollButtons="off">
              <Tab value='permitted' label='Permitted Viewers'/>
              <Tab value='restricted' label='Restricted Viewers'/>
            </Tabs>
          }
        </AppBar>
        <div className={styles.tabContent}>
          {this.selectedTab === 'permitted' && this.renderViewers('permittedViewers', 'Permitted') }
          {this.selectedTab === 'restricted' && this.renderViewers('restrictedViewers', 'Restricted') }
          {!this.canAddViewers && this.renderErrorMessage()}
          <User.UserSelect prefilters={{access_level: 'member', account_type: 'registered_investor'}}/>
        </div>
      </CenteredContent>
    )
  }
}

const styles = StyleSheet({
  wrapper: {
    width: '100%',
    boxSizing: 'border-box',
  },
  tabBar: {
    marginBottom: 50,
  },
  tabContent: {},
  headerRow: {
    display: 'flex',
    flexWrap: 'wrap',
    marginBottom: 40,
    '& h5': {
      flex: 1,
      marginBottom: 10,
    },
    '& button': {
      marginLeft: 10,
      marginBottom: 10,
    }
  },
  pagination: {
    padding: 0
  },
  close: {
    margin: 10,
    flex: 1
  },
  emptyList: {
    background: '#f4f4f4',
    color: 'rgba(0,0,0,0.87)',
    fontWeight: 500,
    fontSize: '0.8125rem',
    padding: 15
  },
  userList: {
    padding: '10px 0 5px'
  },
  actionButtons: {
    whiteSpace: 'nowrap',
    width: 1,
    '& button': {
      width: 32,
      height: 32,
    }
  },
})
export default connect(({dealSheets}) => dealSheets)(Dependent({loader: true, wrapperClassName: styles.wrapper, clearOnLoad: false})(Viewers))